import { clamp } from "@/libs/math"

export const rgbaToHex = (rgba: string) => {
  const [r, g, b, a] = rgba.replace(/rgba?\((.+)\)/, (_, color) => color).split(/,\s*/)

  return `#${[r, g, b, ...(a ? [String(Math.ceil(parseFloat(a) * 255))] : [])]
    .map((v) => clamp(parseInt(v), { min: 0, max: 255 }).toString(16).padStart(2, "0"))
    .join("")}`
}
